export function initializeAPP() {
	initialActiveSidebar();
	//initializeSimplebar();
	initializeOffcanvas();
	BlazorScrollToId();
}

const initialActiveSidebar = () => {
		// Toggle Sidebar
		var toggle = document.querySelector('[data-bs-toggle="sidebar"]');
		
		if (toggle)
		{
			toggle.addEventListener("click", function(event) {
				event.preventDefault();
				document.querySelector('.app').classList.toggle('sidenav-toggled');
			});
		}
}

const initializeSimplebar = () => {
	var treeviewMenu = document.querySelector('.app-menu');

	if (treeviewMenu)
	{
		// Activate sidebar treeview toggle
		document.querySelectorAll('[data-toggle="treeview"]').forEach(element => {
			element.addEventListener("click", function(event)  {
				event.preventDefault();
				if(!element.parentElement.classList.contains('is-expanded')) {
					treeviewMenu.querySelectorAll("[data-toggle='treeview']").forEach(element => {
						element.parentElement.classList.remove('is-expanded');
					});
				}
				element.parentElement.classList.toggle('is-expanded');
			});
		});

		document.querySelectorAll('[data-toggle="treeview."].is-expanded').parentElement.classList.toggle('is-expanded');
	}
}

const initializeOffcanvas = () => {
	var offcanvas = document.querySelector('#menuOffCanvas');

	if (offcanvas) {
		offcanvas.querySelectorAll('.nav-link').forEach(element => {
			element.addEventListener('click', function() {
				var menuActivo = document.querySelector('#menuPrincipal.show');
				if (menuActivo) {
					setTimeout(function () {
						var eventClick = new Event('click');
						document.querySelector("#bs-button").dispatchEvent(eventClick);
					}, 100);
				}
			});
		});	
	}
}

// Wait until page is loaded
document.addEventListener("DOMContentLoaded", () => initializeAPP());

window.initializeAPP = initializeAPP;



function BlazorScrollToId(id) {
	const element = document.getElementById(id);
	if (element instanceof HTMLElement) {
		element.scrollIntoView({
			behavior: "smooth",
			block: "start",
			inline: "nearest"
		});
	}
}

document.addEventListener("DOMContentLoaded", () => BlazorScrollToId());

window.BlazorScrollToId = BlazorScrollToId;